// extracted by mini-css-extract-plugin
export default {"switch":"switch_switch__2ibJN","container":"switch_container__l39TV","label":"switch_label__ns5nh"};